export const DEFAULT_VALUE_SELECT_CHOISE_TIME = "Как можно скорее"
